import { supabase } from '../../lib/supabase';

export type BugReportType = 'bug' | 'incorrect_data' | 'missing_data' | 'suggestion' | 'other';
export type BugReportPriority = 'low' | 'normal' | 'high' | 'critical';
export type BugReportStatus = 'open' | 'reviewing' | 'resolved' | 'rejected';

export interface CreateBugReportInput {
  userId?: number | string | null;
  reportType: BugReportType;
  contextType: string;
  contextId?: string | null;
  title: string;
  description: string;
  pageUrl?: string | null;
  metadata?: Record<string, any>;
  priority?: BugReportPriority;
}

export async function createBugReport(input: CreateBugReportInput) {
  let numericUserId: number | null = null;

  if (input.userId) {
    const parsed = Number(input.userId);
    if (!isNaN(parsed) && parsed > 0) {
      numericUserId = parsed;
    }
  }

  // Se não foi passado um id numérico, tenta resolver através da sessão auth ativa
  if (!numericUserId) {
    try {
      const { data: sessionData } = await supabase.auth.getSession();
      const authUserId = sessionData?.session?.user?.id;
      if (authUserId) {
        const { data: dbUser } = await supabase
          .from('users')
          .select('id')
          .eq('auth_id', authUserId)
          .maybeSingle();
        if (dbUser?.id) {
          numericUserId = Number(dbUser.id);
        }
      }
    } catch {
      // Continua com user_id null caso seja usuário anônimo ou falhe
    }
  }

  const payload: Record<string, any> = {
    user_id: numericUserId,
    report_type: input.reportType || 'bug',
    context_type: input.contextType,
    context_id: input.contextId ? String(input.contextId) : null,
    title: input.title.trim(),
    description: input.description.trim(),
    page_url: input.pageUrl || (typeof window !== 'undefined' ? window.location.href : null),
    metadata: input.metadata || {},
    status: 'open',
    priority: input.priority || 'normal',
  };

  const { data, error } = await supabase
    .from('user_bug_reports')
    .insert([payload])
    .select()
    .single();

  if (error) {
    console.error('Erro ao enviar relatório de bug:', error);
    throw error;
  }

  return data;
}
